import React, { useEffect, useState } from "react";
import "react-responsive-modal/styles.css";
import { useLocation, useNavigate, useSearchParams } from "react-router";
import { student_login_bg } from "../../assets/images/images";
import "../../index.css";
import "./RegisterForm.css";
import BackButton from "../BackButton/BackButton";
import Otp from "./Otp";
import RegisterEmailVerfication from "./RegisterEmailVerfication";
import { useAuth } from "../../../src/features/auth/AuthContext";
import useBranding from "../../hooks/useBranding";
import api from "../../../src/api/api";
import { toast } from "react-toastify";
import { formatApiErrors } from "../../utils/formatApiErrors";


const WelcomeToSrdsForm = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { login } = useAuth();
    const branding = useBranding();
    const activeTab = location.state.role
    const [searchParams] = useSearchParams();
    const [loding, setLoding] = useState(false)

    const redirectPath = searchParams.get("redirect");

    // Store the redirect path if it exists in search params
    if (redirectPath) {
        localStorage.setItem("redirectAfterSignup", redirectPath);
    }
    const redirectLink = localStorage.getItem("redirectAfterSignup");

    const redirectCourse = searchParams.get("redirectToCourse");

    if (redirectCourse) {
        localStorage.setItem("redirectToCourse", redirectCourse);
    }

    const redirectToCoursePath = localStorage.getItem("redirectToCourse");


    const handleSignUpClick = (event) => {
        event.preventDefault();

        if (location.state.status === 'Login') {
            navigate("/signup")
        } else {
            navigate("/login")

        }
    };

    const [showOtpComponent, setShowOtpComponent] = useState(false);
    const [userEmail, setUserEmail] = useState(null);




    const handleSendCode = (email) => {
        if (location.state.status === 'Login') {
            loginUser(email)
        } else {
            signupUser(email)
        }
    };

    const signupUser = async (email, otp = null) => {
        setLoding(true)   
        const failedErrorMessage =
            "Oops, something went wrong. Please try again later.";
        let role = 2;
        if (activeTab === "Student") {
            role = 1;
        } else if (activeTab === "Teacher") {
            role = 2;
        } else if (activeTab === "Parent") {
            role = 3;
        }


        try {

            const emailConverCase = email.toLowerCase()

            const payload = otp ? { email: emailConverCase, role, otp } : { email: emailConverCase, role };
            const response = await api.post('/auth/register-user/', payload);

            setLoding(false)

            if (response?.status === 400) {
                toast.dismiss();
                const error = formatApiErrors(response?.data);
                toast.error(error || response?.data?.message || failedErrorMessage, {
                    position: "top-center",
                });

                return;
            }
            if (
                response?.data?.status === 200 &&
                response?.data?.message ===
                "Verification code has been sent to your email."
            ) {

                setShowOtpComponent(true);
                setUserEmail(email)
                toast.success("Verification code sent successfully", {
                    position: "top-center",
                });
                return;
            }
            if (response?.data?.data?.token === undefined) {

                toast.dismiss();
                const error = formatApiErrors(response?.data);

                toast.error(error || response?.data?.message || failedErrorMessage, {
                    // toast.error('watng', {
                    position: "top-center",
                });
                return;
            }

            const isProfile = response?.data?.data?.is_profile || false
            localStorage.setItem("is_profile", String(isProfile));

            login(response?.data?.data?.token, activeTab, email || "");
            toast.dismiss();
            toast.success("Signup successful.", {
                position: "top-center",
            });
            localStorage.removeItem('emailId')
            if (activeTab === "Student") {

                const { pathname } = location.state || { from: "/dashboard/home" };
                navigate(pathname || "/dashboard/home", {
                    state: { role: activeTab },
                });

            } else if (activeTab === "Teacher") {

                navigate("/dashboard/home", { state: { role: activeTab } });

            } else if (activeTab === "Parent") {
                role = "parent";
            }
        } catch (error) {
            setLoding(false)
            toast.dismiss();
            
            // Handle different types of errors
            let errorMessage = failedErrorMessage;
            
            if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
                errorMessage = "Request timed out. Please check your internet connection and try again.";
            } else if (!error.response) {
                // Network error (no response received)
                if (error.message.includes('Network Error')) {
                    errorMessage = "Network error. Please check your internet connection and try again.";
                } else if (error.message.includes('ERR_NETWORK')) {
                    errorMessage = "Unable to connect to the server. Please check your internet connection.";
                } else {
                    errorMessage = "Connection failed. Please check your internet connection and try again.";
                }
            } else {
                // Server responded with error
                errorMessage = formatApiErrors(error?.response?.data) || failedErrorMessage;
            }
            
            toast.error(errorMessage, {
                position: "top-center",
            });
        }
    };

    const loginUser = async (email, otp = null) => {
        setLoding(true)

        const failedErrorMessage =
            "Oops, something went wrong. Please try again later.";

        try {

            const emailConverCase = email.toLowerCase()
            const payload = otp ? { email: emailConverCase, otp } : { email: emailConverCase };

            const response = await api.post(
                `/auth/login-user/v2/`,
                payload
            );

            // Add your new condition here


            setLoding(false)
            if (response?.status === 400) {

                toast.dismiss();
                const error = formatApiErrors(response?.data);
                toast.error(error || response?.data?.message || failedErrorMessage, {
                    position: "top-center",
                });

                return;
            }
            if (response?.status === 200) {

                if (
                    response?.data?.message ===
                    "Verification code has been sent to your email."
                ) {
                    // Open EmailVerification modal to input the OTP
                    setShowOtpComponent(true);
                    setUserEmail(email)
                    toast.success("Verification code sent successfully", {
                        position: "top-center",
                    });
                    return;
                }
                else {

                    let role = null
                    if (response?.data?.role === 1) {
                        role = 'Student'
                    } else if (response?.data?.role === 2) {
                        role = 'Teacher'
                    } else if (response?.data?.role === 3) {
                        role = 'Parent'
                    } else if (response?.data?.role === 4) {
                        role = 'School Admin'
                    } else if ((response?.data?.role === 5)) {
                        role = 'Super Admin'
                    }


                    const isProfile = response?.data?.is_profile || false
                    localStorage.setItem("is_profile", String(isProfile));

                    login(response?.data?.token, role, email || "");
                    toast.dismiss();
                    toast.success("Login successful.", {
                        position: "top-center",
                    });


                    localStorage.removeItem('emailId')
                    if (role === "Student") {

                        if (redirectLink !== null && redirectLink !== "") {

                            navigate(redirectLink);
                            return;
                        }
                        if (redirectToCoursePath !== null && redirectToCoursePath !== "") {

                            navigate(redirectToCoursePath);
                            return;
                        }

                        const { pathname } = location.state || { from: "/dashboard/home" };
                        navigate(pathname || "/dashboard/home", {
                            state: { role: activeTab },
                        });
                    }
                    else if (role === "Teacher") {
                        navigate("/dashboard/home", { state: { role: activeTab } });
                    }
                    else if (role === "Parent") {
                        role = "parent";
                    }
                }
            }
        } catch (error) {
            setLoding(false)
            toast.dismiss();
            
            // Handle different types of errors
            let errorMessage = failedErrorMessage;
            
            if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
                errorMessage = "Request timed out. Please check your internet connection and try again.";
            } else if (!error.response) {
                // Network error (no response received)
                if (error.message.includes('Network Error')) {
                    errorMessage = "Network error. Please check your internet connection and try again.";
                } else if (error.message.includes('ERR_NETWORK')) {
                    errorMessage = "Unable to connect to the server. Please check your internet connection.";
                } else {
                    errorMessage = "Connection failed. Please check your internet connection and try again.";
                }
            } else {
                // Server responded with error
                errorMessage = formatApiErrors(error?.response?.data) || failedErrorMessage;
            }
            
            toast.error(errorMessage, {
                position: "top-center",
            });
        }

    }


    const handleBackBTN = () => {
        if (!showOtpComponent) {
            navigate(-1)
        } else {
            setShowOtpComponent(false);
        }
    }
    return (
        <div className="welcome-to-srds-form-section">
            <div className="login-mani-wrapper">
                <form
                    action=""
                    className="register-left-section"
                // onSubmit={handleSubmit}
                >
                    <div
                        className="back-home-btn"
                        onClick={() => {
                            navigate("/");
                        }}
                    >
                        <span>
                            <i className="fa-solid fa-chevron-left"></i>
                        </span>
                        <span>Home</span>
                    </div>
                    <div className="Register-container-wrapper">
                        <h2 onClick={() => {
                            navigate("/");
                        }}>Welcome to <span>{branding.productName}</span></h2>
                        <div className="login-with-Verification-code">
                            <p>{location.state.status} with Verification Code</p>
                        </div>
                        {/* Conditionally render RegisterEmailVerfication or Otp */}
                        {!showOtpComponent ? (
                            <RegisterEmailVerfication
                                handleSendCode={handleSendCode} // To show Otp after sending the code
                                loding={loding}
                            />
                        ) : (
                            <Otp
                                email={userEmail}
                                signupUser={location.state.status === 'Login' ? loginUser : signupUser}
                                setShowOtpComponent={setShowOtpComponent}
                                loding={loding}
                            />
                        )}
                    </div>
                    <div className="Already-have-an-accout-wrapper">
                        {/* <BackButton buttonName="Back" /> */}
                        <div className='Back_button' onClick={handleBackBTN} style={{ cursor: "pointer", display: "flex", alignItems: "center", color: "#0068ff", cursor: "pointer", marginBottom: "26px" }}>
                            <i className="fa-solid fa-chevron-left"></i>
                            <span style={{ padding: " 0px 5px" }}>Back </span>
                        </div>
                        <p className="terms-and-Privacy-policy">
                            By Logging In {branding.productName}, you agree to our Terms of
                            use & Privacy policy
                        </p>
                        <div className="Already-have-an-accout-folder">
                            <span>
                                Don't have an account?{" "}
                                <a href="#" onClick={handleSignUpClick}>
                                    {" "}
                                    {location.state.status === 'Login' ? 'Sign up' : 'Login'}
                                </a>
                            </span>
                        </div>
                    </div>
                </form>
                <div className="register-right-section">
                    <div className="signup-image">
                        <img
                            src={student_login_bg}
                            alt="Background"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WelcomeToSrdsForm;